import { sendWebsocketMessage } from '../../../../../../App';

export function removeTradePlanByIds(idArray){
  const msg = {
    messageType: 'removeTradePlansById',
    idArray,
  };
  sendWebsocketMessage(msg);
}
